import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import DataTable from "react-data-table-component";
import React, { useEffect, useState, useContext } from "react";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { toast, ToastContainer } from 'react-toastify';
import { all } from "axios";
import { Color } from "antd/es/color-picker";


const MyCart = () => {

    const { cart, updateCart } = useContext(CartContext);
    const [cartData, setCartData] = useState([]);

    const [summary, setSummary] = useState({ mrp: 0, discount: 0, price: 0, gstAmount: 0, subTotal: 0, shipping: 0, shippingGST: 0, totalAmount: 0, });
    const navigate = useNavigate();

    const { currencyContxt } = useContext(CurrencyContext); // Use context

    // Function to fetch Cart List data
    const fetchCartListData = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        if (userInfo && userInfo.buyer_id) {
            try {
                const cartlistResponse = await fetch(`https://igapi.heuristticminds.com/api/CartList/Get-GetCartListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userInfo.token}`,  // Pass user token if required
                    },
                });
                const cartlistData = await cartlistResponse.json();
                setCartData(cartlistData);
                updateCart(cartlistData); // Update context
                calculateSummary(cartlistData); // Calculate summary
            } catch (error) {
                console.error("Error fetching wishlist data:", error);
            }
        } else {
            // Fallback to localStorage if user is not logged in
            const localCartlist = localStorage.getItem('cart');
            if (localCartlist) {
                const parsedCart = JSON.parse(localCartlist);
                setCartData(parsedCart);
                calculateSummary(parsedCart); // Calculate summary
            }
        }
    };

    // Calculate price summary
    const calculateSummary = (cartData) => {
        // Filter out items with status 3 (Sold Out) or 5 (Sold by Artist)
    const validItems = cartData.filter(item => item.status !== 3 && item.status !== 5);

    let mrp = validItems.reduce((acc, item) => acc + item.mrp, 0);
    let discount = validItems.reduce((acc, item) => acc + item.discount, 0);
    let price = validItems.reduce((acc, item) => acc + item.price, 0);
    let gstAmount = validItems.reduce((acc, item) => acc + item.gst, 0); // Assuming GST amount from API

    // Check the currency type and apply the appropriate shipping cost
    let subTotal = 0;
    let shipping = 0;
    let shippingGST = 0;

    if (currencyContxt.currency === 'INR') {
        subTotal = validItems.reduce((acc, item) => acc + (item.mrp - item.discount + item.gst), 0);
        shipping = validItems.reduce((acc, item) => acc + item.shippingINR, 0);
        shippingGST = validItems.reduce((acc, item) => acc + (item.shippingINR * item.shippingGST / 100), 0);
    } else {
        subTotal = validItems.reduce((acc, item) => acc + (item.mrp - item.discount), 0);
        shipping = validItems.reduce((acc, item) => acc + item.shippingOthers, 0);
        shippingGST = validItems.reduce((acc, item) => acc + (item.shippingOthers * item.shippingGST / 100), 0);
    }

    setSummary({
        mrp: mrp.toFixed(2),
        discount: discount.toFixed(0),
        price: price.toFixed(0),
        gstAmount: gstAmount.toFixed(2),
        subTotal: subTotal.toFixed(2),
        shipping: shipping.toFixed(2),
        shippingGST: shippingGST.toFixed(2),
        totalAmount: currencyContxt.currency === 'INR' 
            ? (mrp - discount + gstAmount + shipping + shippingGST).toFixed(2)
            : (mrp - discount + shipping + shippingGST).toFixed(2), 
    });
    };

    useEffect(() => {
        if (cart.length > 0) {
            calculateSummary(cart);
        }
    }, [cart, currencyContxt]); // Recalculate when cart or currency changes

    useEffect(() => {
        fetchCartListData();
    }, []);

    const handleDelete = async (id, productId) => {
         // Ask for confirmation before deleting
    if (window.confirm('Are you sure you want to delete this item?')) {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));

        if (userInfo && userInfo.buyer_id) {
            // User is logged in, delete from the database
            try {
                const response = await fetch(`https://igapi.heuristticminds.com/api/CartList/Delete-DeleteCartListDetails?id=${id}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userInfo.token}`,  // Pass user token if required
                    },
                });

                if (response.ok) {
                    // Remove the item from the local state and update the cart context
                    const updatedCart = cart.filter(item => item.product_id !== productId);
                    updateCart(updatedCart);
                    setCartData(updatedCart);
                    calculateSummary(updatedCart);

                    toast.success('Item removed from cart!');
                    if (updatedCart.length === 0) {
                        toast.info('Your cart is empty. Redirecting to home.');
                        navigate('/');
                    }
                } else {
                    toast.error('Failed to remove item from cart.');
                }
            } catch (error) {
                console.error('Error deleting item from database:', error);
                toast.error('Error deleting item.');
            }
        } else {
            // User is not logged in, delete from local storage
            const localCart = JSON.parse(localStorage.getItem('cart')) || [];
            const updatedCart = localCart.filter(item => item.product_id !== productId);

            // Update localStorage and local state
            localStorage.setItem('cart', JSON.stringify(updatedCart));
            setCartData(updatedCart);
            updateCart(updatedCart);
            calculateSummary(updatedCart);

            toast.success('Artwork removed from cart!');
            if (updatedCart.length === 0) {
                toast.info('Your cart is empty. Redirecting to home.');
                navigate('/');
            }
        }
    }
    };



    const columns = [
        {
            name: "Art Image",
            cell: row => <div className={`${row.status === 3 ? 'soldout' : row.status === 5 ? 'soldbyartist' : ''}`} style={{ width: "100px", margin: "8px 0", height: '100px' }}><img src={`../images/products/thumbnail/${row.image}`} alt='' style={{ width: "100px", height: '100px' }} /></div>,
            width: "120px"
        },
        {
            name: "Artwork Details",
            selector: row => <><div>
                <h2 className="fs-6">{row.productTitle}</h2>
                <span className="d-block">{row.category}: {row.categoryType}</span>
                <span className="d-block">Art by: {row.artistName}</span>
                {/* Hide Price & Discount if status is 3 (Sold Out) or 5 (Sold by Artist) */}
                {!(row.status === 3 || row.status === 5) && (
                    <>
                        <span className="d-block">
                            Artwork Price: {currencyContxt.icon} {(row.mrp / currencyContxt.value).toFixed(2)}
                        </span>
                        {row.discountRate > 0 && (
                            <span className="d-block">Discount: {row.discountRate}%</span>
                        )}
                    </>
                )}
            </div>
            </>,
            width: "230px"
        },
        {
            name: "Price",
            selector: row => !(row.status === 3 || row.status === 5) ? (
                <span style={{ fontSize: "16px" }}>
                    {currencyContxt.icon} {(row.price / currencyContxt.value).toFixed(2)}
                </span>
            ) : null,
            width: "120px",
        },
        ...(currencyContxt.id === 4
            ? [
                {
                    name: "GST Amount",
                    selector: row =>  !(row.status === 3 || row.status === 5) ? (
                        <span style={{ fontSize: "16px" }}>
                            {currencyContxt.icon} {(row.gst / currencyContxt.value).toFixed(2)}
                        </span>
                    ): null,
                    width: "120px"
                }, 
                {
                    name: "Price (incl. GST)",
                    selector: row =>  !(row.status === 3 || row.status === 5) ? (
                        <span style={{fontSize:"16px"}}>
                            {currencyContxt.icon} {(row.gstPrice / currencyContxt.value).toFixed(2)}
                        </span>
                    ):null,
                    width:"150px"
                },
            ]
            : []),
        
        {
            name: "Action",
            selector: row => <> <button className="btn1 bg-light" style={{ minWidth: "50px" }} onClick={() => handleDelete(row.id, row.product_id)}><i className="bi bi-trash3-fill"></i></button></>,
            width: "100px"
        }


    ];
    const handleCheckOut = () => {
        debugger;
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        if (userInfo && userInfo.buyer_id) {
            const outOfStockItems = cartData.filter(item => item.status === 3 || item.status === 5);
            if (outOfStockItems.length > 0) {
                alert('Please remove the sold artwork before proceeding to checkout.');
            }
            else {
                navigate('/checkoutAddress');
            }
        }
        else {
            alert('To Checkout , please login with your registered mobile number or register yourself..');
            navigate('/buyerLogin');
        }

    };



    return (
        <>
            <Header />
            <div style={{ marginTop: '150px' }}>
                <div className="container">

                    <div className="row">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-4">
                                <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                <li className="breadcrumb-item">My Cart</li>
                            </ol>
                        </nav>
                        <div className="col-sm-8">
                            <div className="cart_list">
                                <DataTable
                                    columns={columns}
                                    data={cartData}
                                    className="cartTB"
                                />
                            </div>
                        </div>
                        <div className="col-sm-4 ps-5">
                            <div className="bg-dark text-white p-2">
                                Price Summary ({currencyContxt.currency})
                            </div>
                            <div className="bg-light p-3 border">
                                <div className="pricetype">
                                    Artwork Price <span> {(summary.mrp / currencyContxt.value).toFixed(2)}</span>
                                </div>
                                {parseFloat(summary.discount) > 0 && (
                                    <div className="pricetype">
                                            Discount<span style={{ color: 'red' }}>- {(summary.discount / currencyContxt.value).toFixed(2)}</span>
                                    </div>
                                )}
                                {currencyContxt.id === 4 &&(
                                <div className="pricetype">
                                    GST<span>{(summary.gstAmount / currencyContxt.value).toFixed(2)}</span>
                                </div>
                                )}
                                {!(parseFloat(summary.discount) === 0 && currencyContxt.id != 4) && (
                                <div className="pricetype">
                                    Sub Total<span>{(summary.subTotal / currencyContxt.value).toFixed(2)}</span>
                                </div>
                                )}
                               
                                <div className="pricetype">
                                    Shipping Charge
                                        <span>
                                            {parseFloat(summary.shipping) === 0 ? "Free" : (summary.shipping / currencyContxt.value).toFixed(2)}
                                        </span>
                                </div>
                               
                                {parseFloat(summary.shipping) !== 0 && (
                                <div className="pricetype">
                                    Shipping GST<span>{(summary.shippingGST / currencyContxt.value).toFixed(2)}</span>
                                </div>
                                )}
                                <div className="pricetype">
                                    <b> Total Amount</b><span><b>
                                        {currencyContxt.icon}&nbsp;{(summary.totalAmount / currencyContxt.value).toFixed(2)}
                                    </b></span>

                                </div>
                            </div>
                            <button onClick={handleCheckOut} className="btn2 bg-primary text-white border-0 mt-3">Checkout</button>


                        </div>
                    </div>
                </div>
                <ToastContainer position="bottom-right" />
            </div>
            <Footer />
        </>
    )
}

export default MyCart;